import { request } from "../../apis";

export const apiGetUser = (params) => request("get", `/user/get_user`, params, true);

export const apiGetCs = (params) => request("get", `/index/get_user_kefu`, params, true);

export const apiGetMyIncome = (params) => request("get", `/user/revenue_record`, params, true);

export const apiGetInvitation = () => request("get", `/user/invitation`, {}, true);
